module.exports = __webpack_public_path__ + "static/media/18ECA23.e067d655.jpg";